import { render, staticRenderFns } from "./suporte-fornecedores.vue?vue&type=template&id=13c305c4"
import script from "./suporte-fornecedores.vue?vue&type=script&lang=ts"
export * from "./suporte-fornecedores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports